module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"login_banner_header":"","login_banner_text":""},"en":{"login_banner_header":"","login_banner_text":""}}')
  delete Component.options._Ctor
}
